module.exports = __webpack_public_path__ + "media/images/angle-up-c-3ab13aa7e20f4946b1e9503e47f9fec67c96de8822165de5bd3a3e17b23cf80c.png";